import styled from "@emotion/styled";
import AccordionSummary from "@mui/material/AccordionSummary";
import { AccordionDetails } from "@mui/material";

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
	paddingLeft: "1rem",
	backgroundColor: theme.project.colors.backgroundColors.warning,
	padding: "8px 16px",
	minHeight: "0 !important",
	"> span:first-of-type": {
		display: "flex",
		alignItems: "center",
		gap: "8px",
		margin: 0,
		span: {
			...theme.project.typography.heading.h6,
			color: "var(--orange-500)"
		}
	}
}));

export const OrderDetailsOnBackorderAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "12px",
	"> p:first-of-type": {
		...theme.project.typography.subtitle.subtitle2,
		color: "var(--orange-500)",
		margin: 0
	}
}));
